const ContentTypes = {
  TITLE: 'title',
  SYNOPSIS: 'synopsis'
}

export default ContentTypes
